import React, { createContext } from 'react';
import { ContextProviderValue } from '../models/product';
import { useProducts } from '../hooks/useProducts';
import { useCart } from '../hooks/useCart';

export const ProductContext = createContext<ContextProviderValue>({} as ContextProviderValue);

interface Props {
  children: JSX.Element[] | JSX.Element;
}

const ProductsContextProvider = ({ children }: Props) => {
  const { products, isLoading, productsError } = useProducts();
  const { cartItems, addToCart, removeFromCart, setCartQuantity, clearCart } = useCart(products);

  const contextValue: ContextProviderValue = {
    cartItems,
    products,
    isLoading,
    productsError,
    addToCart,
    removeFromCart,
    setCartQuantity,
    clearCart,
  };

  return (
    <ProductContext.Provider value={contextValue}>
      {children}
    </ProductContext.Provider>
  );
};

export default ProductsContextProvider;
